import { Controller } from "@hotwired/stimulus"

// MC-1267: re-renders the inbound-rule action-settings fieldset when a
// *controlling* field changes — one another setting's visibility depends on
// (e.g. dispatch-worker's `subject`). On change it points the settings Turbo
// Frame at the `action_fields` endpoint, carrying the action name and the
// fieldset's current values, so the server re-renders from the schema showing
// only the settings that still apply while keeping what was already entered for
// the ones that stay. Progressive: with no JS the fieldset still submits and
// the server renders the applicable settings (and re-validates) on save.
export default class extends Controller {
  static values = { url: String, frame: String, actionName: String }

  reload() {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("action_name", this.actionNameValue)

    // Carry every current fieldset value so still-visible settings survive the
    // swap; the names already encode their nesting (`inbound_rule[...][...]`).
    const controls = frame.querySelectorAll(
      "input[name], select[name], textarea[name]"
    )
    controls.forEach((control) => {
      if (
        (control.type === "checkbox" || control.type === "radio") &&
        !control.checked
      ) {
        return
      }
      url.searchParams.append(control.name, control.value)
    })

    frame.setAttribute("src", url.pathname + url.search)
  }
}
